import { AnyAction, combineReducers } from "redux";
import { Purchases } from "../../../../constants/Purchases";
import {
  IProductDataState,
  IProductState,
  ISetProductAction
} from "./types";
import ActionTypes from '../../../../constants/ActionTypes';
import Contracts from "../../../../constants/Contracts";
import PaymentMethods from "../../../../constants/PaymentMethods";

const initialState: IProductState = {
  item: {},
};

const initialProductDataState: IProductDataState = {
  tariff: 0,
  color: 0,
  contract: 24,
  cosmosInstallments: 24,
  participation: 0,
  cosmosModel: 'telco',
  paymentType: PaymentMethods.INSTALLMENT_OFFER_24,
  purchase: Purchases.SUBSIDY,
  contractType: Contracts.NEW,
  installments: false,
  type: "",
  productId: 0,
  isFilterEnable: false,
};

const productReducer = (
  state = initialState,
  action: ISetProductAction,
): IProductState => {
  switch (action.type) {
  case ActionTypes.PRODUCT.SET:
    return {
      ...state,
      item: action.payload,
    };
  }

  return state;
};

const productDataReducer = (state = initialProductDataState, action: AnyAction) => {
  switch (action.type) {
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_COLOR:
    return {
      ...state,
      color: action.payload.color,
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_CONTRACT_OBLIGATION:
    return {
      ...state,
      contract: action.payload.contract,
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_COSMOS_INSTALLMENTS:
    return {
      ...state,
      cosmosInstallments: action.payload.cosmosInstallments,
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_PARTICIPATION:
    return {
      ...state,
      participation: action.payload.participation,
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_COSMOS_MODEL:
    return {
      ...state,
      cosmosModel: action.payload.cosmosModel
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_PAYMENT_TYPE:
    return {
      ...state,
      paymentType: action.payload.paymentType
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_INSTALLMENTS_OVER_BILL_PERIOD:
    return {
      ...state,
      installments: action.payload.installmentsOverBillPeriod,
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_TP_ID:
    return {
      ...state,
      tariff: action.payload.tariff,
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_PRODUCT_DATA:
    return {
      ...state,
      tariff: action.payload.tariff,
      color: action.payload.color,
      contract: action.payload.contract,
      cosmosInstallments: action.payload.cosmosInstallments,
      cosmosModel: action.payload.cosmosModel,
      participation: action.payload.participation,
      purchase: action.payload.purchase,
      contractType: action.payload.contractType,
      paymentType: action.payload.paymentType,
      installments: action.payload.installments,
      type: action.payload.type,
      productId: action.payload.productId,
      isFilterEnable: action.payload.isFilterEnable,
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_PURCHASE:
    return {
      ...state,
      purchase: action.payload.purchase,
    };
  case ActionTypes.PRODUCT.PRODUCT_DATA.SET_CONTRACT_TYPE:
    return {
      ...state,
      contractType: action.payload.contractType,
    };
  }

  return state;
};

const productData = combineReducers({
  product: productReducer,
  productData: productDataReducer,
});


export default productData;
